// Holds the event listeners per plugin.
export var EVENT_LISTENERS_RECORD = {};
/**
 * Maintains a record of event listeners per plugin.
 *
 * @param {string} pluginName
 * @param {EventListenerParams} params
 */
export var addToEventListenersRecord = function (pluginName, params) {
    if (!EVENT_LISTENERS_RECORD[pluginName]) {
        EVENT_LISTENERS_RECORD[pluginName] = [];
    }
    EVENT_LISTENERS_RECORD[pluginName].push(params);
};
/**
 *
 * Invoking this method will remove the registered event listeners for that plugin.
 *
 * @param {string} pluginName
 */
export var removeEventListeners = function (pluginName) {
    if (EVENT_LISTENERS_RECORD[pluginName]) {
        EVENT_LISTENERS_RECORD[pluginName].forEach(function (_a) {
            var element = _a.element, callback = _a.callback, eventType = _a.eventType;
            element.removeEventListener(eventType, callback);
        });
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXZlbnQtbGlzdGVuZXItdXRpbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdXRpbHMvZXZlbnQtbGlzdGVuZXItdXRpbHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBSUEsd0NBQXdDO0FBQ3hDLE1BQU0sQ0FBQyxJQUFNLHNCQUFzQixHQUE2QixFQUFFLENBQUM7QUFFbkU7Ozs7O0dBS0c7QUFDSCxNQUFNLENBQUMsSUFBTSx5QkFBeUIsR0FBRyxVQUFDLFVBQWtCLEVBQUUsTUFBMkI7SUFDdkYsSUFBSSxDQUFDLHNCQUFzQixDQUFDLFVBQVUsQ0FBQyxFQUFFO1FBQ3ZDLHNCQUFzQixDQUFDLFVBQVUsQ0FBQyxHQUFHLEVBQUUsQ0FBQztLQUN6QztJQUVELHNCQUFzQixDQUFDLFVBQVUsQ0FBQyxDQUFDLElBQUksQ0FBQyxNQUFNLENBQUMsQ0FBQztBQUNsRCxDQUFDLENBQUM7QUFFRjs7Ozs7R0FLRztBQUNILE1BQU0sQ0FBQyxJQUFNLG9CQUFvQixHQUFHLFVBQUMsVUFBa0I7SUFDckQsSUFBSSxzQkFBc0IsQ0FBQyxVQUFVLENBQUMsRUFBRTtRQUN0QyxzQkFBc0IsQ0FBQyxVQUFVLENBQUMsQ0FBQyxPQUFPLENBQUMsVUFBQyxFQUFxRDtnQkFBbkQsT0FBTyxhQUFBLEVBQUUsUUFBUSxjQUFBLEVBQUUsU0FBUyxlQUFBO1lBQ3hFLE9BQU8sQ0FBQyxtQkFBbUIsQ0FBQyxTQUFTLEVBQUUsUUFBUSxDQUFDLENBQUM7UUFDbkQsQ0FBQyxDQUFDLENBQUM7S0FDSjtBQUNILENBQUMsQ0FBQyJ9